<template>
  <print246 v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'file', label: '필수 첨부서류', value: 'file', labelStyle: 'color:#EA5455' },
      ]"
      :board="this.board"
      :is-print="isPrint"
      :multiple-disaster="true"
    />

    <!--    작업구분-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업구분</h5>

      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-3 flex items-center" style="align-self: flex-start; word-break: keep-all" v-for="checkbox in form.inspectionList" v-bind:key="checkbox.id">
          <div v-if="isPrint || board.readonly" class="flex">
            <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            {{ checkbox.label }}
          </div>
          <label v-else class="flex">
            <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
            {{ checkbox.label }}
          </label>
        </div>
      </div>
    </div>

    <!--    장비 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 장비 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>장비 업체명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" />
        </div>
        <div>
          <div>장비 운전원</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" />
        </div>

        <div>
          <div>장비 종류(기종 및 모델명)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" />
        </div>
        <div>
          <div>장비 형식 및 규격(정격하종)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" />
        </div>
        <div>
          <div>작업지휘자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_7" />
        </div>
        <div>
          <div>작업유도자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.inputB_8" />
        </div>
      </div>
    </div>

    <!--    목록표 -->
    <div class="mt-4" v-for="(inspection, indexRows) in form.inspectionList">
      <table-inspect
        class="mt-2"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.label"
        :list="inspection.content"
        :is-not-dot-in-label="true"
        table-header-title="점검사항"
        table-header-note="비고"
        v-if="inspection.check"
        header-n-a="N/A"
        @update-list-check="
          (param1, param2, param3) => {
            updateListCheck(indexRows, param1, param2, param3);
          }
        "
      />

      <table-inspect-division
        class="mt-2"
        v-bind:key="inspection.id"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="true"
        :title="inspection.title"
        :list="inspection.list"
        v-if="inspection.check"
        header-n-a="N/A"
        @update-list-check="
          (param1, param2, param3) => {
            updateListCheck(indexRows, param1, param2, param3);
          }
        "
      />
    </div>

    <!-- 확인자 -->
    <div>
      <div class="mt-4">
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>안전관리자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>관리책임자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" title="작업 계획도 및 관련 도면 첨부"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableInspectDivision from "@/components/TableInspectDivision";
import Print246 from "@/views/boards/single-page/246/Print.vue";
import SignField from "@/components/SignField.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    SignField,
    Print246,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        file: { required },
      },
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text;
    },
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.file.required) return "필수 첨부서류를 첨부해주세요.";
      }
    },
  },
  computed: {
    getInspectionListTitle() {
      let result = "";
      for (const data of this.form.inspectionList) {
        if (data.check) {
          result += `${data.label} , `;
        }
      }

      if (result.length > 0) {
        result = result.substring(0, result.length - 2);
      }
      return result;
    },
    inspectionList() {
      return [
        ///sample///
        /*{
          id: 3,
          label: '터널굴착작업',
          check: false,
          title: '사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)',
          list: [
            {
              headerTitle: '사전조사 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [

              ]
            },
            {
              headerTitle: '작업계획서 내용',
              headerYesTitle: '작성',
              headerNoTitle: '미작성',
              isTypeMode : true,
              isInputMode: false,
              list: [

              ]
            }
          ]
        },*/
        //////
        {
          id: 1,
          label: "타워크레인을 설치·조립·해체하는 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          content: [
            {
              id: 1,
              label: "1. 설치/해체 순서, 방법을 근로자는 주지하고 있는가?",
              is_checked: "",
            },
            {
              id: 2,
              label: "2. 상승작업 중 턴테이블 하부와 텔레스코핑케이지의 볼트, 핀 등은 견고히 체결되었는가?",
              is_checked: "",
            },
            {
              id: 3,
              label: "3. 텔레스코핑 슈 등 유압장치는 정상적으로 작동하고 있는가?",
              is_checked: "",
            },
            {
              id: 4,
              label: "4. 작업팀원 역할분담과 지휘명령계통이 명확한가?",
              is_checked: "",
            },
            {
              id: 5,
              label: "5. 풍속 등 기상 상황은 확인하였는가?",
              is_checked: "",
            },
            {
              id: 6,
              label: "6. 대차 레일, 부재 등은 손상·변형이 없는가?",
              is_checked: "",
            },
            {
              id: 7,
              label: "7. 이동식크레인 정격하중, 위치 선정 등은 적정한가?",
              is_checked: "",
            },
            {
              id: 8,
              label: "8. 줄걸이 용구(슬링 등)은 적정한가?",
              is_checked: "",
            },
            {
              id: 9,
              label: "9. 상승작업 중 턴테이블 하부와 텔레스코핑 케이지의 볼트, 핀 등은 견고히 체결되었는가?",
              is_checked: "",
            },
          ],
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              headerNATitle: "N/A",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "타워크레인의 종류 및 형식",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "설치·조립 및 해체순서",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "작업도구·장비·가설설비(假設設備) 및 방호설비",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "작업인원의 구성 및 작업근로자의 역할 범위",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "제142조에 따른 지지 방법",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "차량계 하역운반기계 등을 사용하는 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          content: [
            {
              id: 1,
              label: "1. 작업계획서를 작성하고 계획에 따라 작업하는가?",
              is_checked: "",
            },
            {
              id: 2,
              label: "2. 작업지휘자를 지정하여 작업계획서에 따라 작업을 지휘하는가?",
              is_checked: "",
            },
            {
              id: 3,
              label: "3. 청소차 적재함 등 승차석이 아닌 위치에 근로자가 탑승하지는 않는가?",
              is_checked: "",
            },
            {
              id: 4,
              label: "4. 운전자는 제한속도를 준수하는가?",
              is_checked: "",
            },
            {
              id: 5,
              label: "5. 운전자가 운전위치 이탈 시 시동키 분리 등 안전사항을 지키는가?",
              is_checked: "",
            },
            {
              id: 6,
              label: "6. 하역·운반 중인 화물이나 차량계 하역운반기계에 접촉될 우려가 있는곳에 근로자의 출입을 금지하는가?",
              is_checked: "",
            },
            {
              id: 7,
              label: "7. 차량계 하역운반기계에 화물 적재 운전자의 시야 확보 등 안전사항을 지키는가?",
              is_checked: "",
            },
            {
              id: 8,
              label: "8. 차량계 하역운반기계를 화물자동차에 싣거나 내리는 작업을 할 때 전도·전락 위험을 방지하고 있는가?",
              is_checked: "",
            },
            {
              id: 9,
              label: "9. 차량계 하역운반기계는 화물의 적재·하역 등 주된 용도에만 사용하는가?",
              is_checked: "",
            },
            {
              id: 10,
              label: "10. 차량계 하역운반기계의 수리 또는 부속장치의 장착 및 해체작업 시 작업 지휘자를 지정하여 작업을 지휘하는가?",
              is_checked: "",
            },
            {
              id: 11,
              label: "11. 차량에는 백밀러, 룸밀러 및 CCTV 등이 설치되었는가?",
              is_checked: "",
            },
            {
              id: 12,
              label: "12. 운전자는 운전 시 안전벨트를 항상 착용하는가?",
              is_checked: "",
            },
            {
              id: 13,
              label: "13. 차량은 정기적으로 검사를 받고 있는가?",
              is_checked: "",
            },
            {
              id: 14,
              label: "14. 폐기물을 하역하는 동안 차량들은 차량 하나의 넓이만큼 서로 떨어져 있는가?",
              is_checked: "",
            },
            {
              id: 15,
              label: "15. 모든 근로자들은 작업장 내에서 쉽게 눈에 띄는 작업복을 착용하는가?",
              is_checked: "",
            },
          ],
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              headerNATitle: "N/A",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "해당 작업에 따른 추락·낙하·전도·협착 및 붕괴 등의 위험 예방대책",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "차량계 하역운반기계등의 운행경로 및 작업방법",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 3,
          label: "차량계 건설기계를 사용하는 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          content: [
            {
              id: 1,
              label: "1. 차량계 건설기계에 대한 작업계획을 수립하여 계획대로 시행하고 있는가?",
              is_checked: "",
            },
            {
              id: 2,
              label: "2. 차량계 건설기계는 유자격자가 운전하고 있는가?",
              is_checked: "",
            },
            {
              id: 3,
              label: "3. 폭풍, 폭우, 폭성 등의 악천후 시 작업을 중지하고 있는가?",
              is_checked: "",
            },
            {
              id: 4,
              label: "4. 유도자를 배치하여 작업을 유도하고 있는가?",
              is_checked: "",
            },
            {
              id: 5,
              label: "5. 일정한 방법을 정하여 신호하고 있는가?",
              is_checked: "",
            },
            {
              id: 6,
              label: "6. 기계의 작업범위 내에 관계자외의 출입을 금지하고 있는가?",
              is_checked: "",
            },
            {
              id: 7,
              label: "7. 작업전 운전자 및 근로자 안전교육을 실시하고 있는가?",
              is_checked: "",
            },
            {
              id: 8,
              label: "8. 지정된 제한속도를 준수하고 있는가?",
              is_checked: "",
            },
            {
              id: 9,
              label: "9. 승차석 이외의 위치에 근로자가 탑승하지 않고 있는가?",
              is_checked: "",
            },
            {
              id: 10,
              label: "10. 운전석 이탈시 원동기 정지, 브레이크 작동 등 이탈방지조치를 하고, 버킷 등 작업장치를 지면에 내려놓고 있는가?",
              is_checked: "",
            },
            {
              id: 11,
              label: "11. 사용전 안전장치 이상 유무를 확인하였는가?\n※ 안전장치 : 전조등, 경보장치, 헤드가드, 붐 전도방지 장치, 붐 권상드럼 역회전방지장치, 기타",
              is_checked: "",
            },
            {
              id: 12,
              label: "12. 건설기계를 싣거나 내리는 작업은 평탄하고 견고한 장소에서 실시하는가?",
              is_checked: "",
            },
            {
              id: 13,
              label: "13. 운반기계의 바퀴에 굄목 등을 확실하게 받치고 있는가?",
              is_checked: "",
            },
          ],
          list: [
            {
              headerTitle: "사전조사 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              headerNATitle: "N/A",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "해당 기계의 굴러 떨어짐, 지반의 붕괴 등으로 인한 근로자의 위험을 방지하기 위한 해당 작업장소의 지형 및 지반상태",
                  is_checked: "",
                },
              ],
            },
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              headerNATitle: "N/A",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "사용하는 차량계 건설기계의 종류 및 성능",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "차량계 건설기계의 운행경로 ",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "차량계 건설기계에 의한 작업방법",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 4,
          label: "중량물의 취급 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          content: [
            {
              id: 1,
              label: "① 화물의 종류, 형상 등에 적합한 운반ㆍ취급방법 선정",
              is_checked: "",
              title: "1. 인력 및 이동대차 작업",
              titleColor: "#f9f9f9",
            },
            {
              id: 2,
              label: "② 적재 화물의 종류별로 규정된 적재방법 준수",
              is_checked: "",
              title: "1. 인력 및 이동대차 작업",
            },
            {
              id: 3,
              label: "③ 올바른 인력운반 취급요령 준수",
              is_checked: "",
              title: "1. 인력 및 이동대차 작업",
            },
            {
              id: 4,
              label: "④ 임의 구름방지장치 부착 등 이동대차 안전장치 부착",
              is_checked: "",
              title: "1. 인력 및 이동대차 작업",
            },
            {
              id: 5,
              label: "⑤ 인력 및 이동대차 운반 안전통행로 확보",
              is_checked: "",
              title: "1. 인력 및 이동대차 작업",
            },
            {
              id: 6,
              label: "① 무자격자(기능, 경험) 에 의한 운전 금지",
              is_checked: "",
              title: "2. 지게차 작업",
              titleColor: "#f9f9f9",
            },
            {
              id: 7,
              label: "② 헤드가드, 백레스트, 안전벨트 등 운전자 보호장치 부착",
              is_checked: "",
              title: "2. 지게차 작업",
            },
            {
              id: 8,
              label: "③ 지게차와 보행자 운행통로 구획 관리",
              is_checked: "",
              title: "2. 지게차 작업",
            },
            {
              id: 9,
              label: "④ 적재하중 및 제한속도 준수",
              is_checked: "",
              title: "2. 지게차 작업",
            },
            {
              id: 10,
              label: "① 과부하 방지장치 등 크레인 각종 방호장치 정상 기능 유지",
              is_checked: "",
              title: "3. 크레인 작업",
              titleColor: "#f9f9f9",
            },
            {
              id: 11,
              label: "② 운전자와 지정신호수 간 일정한 신호에 의한 화물 운반",
              is_checked: "",
              title: "3. 크레인 작업",
            },
            {
              id: 12,
              label: "③ 안전모, 안전화 등 개인보호구 착용",
              is_checked: "",
              title: "3. 크레인 작업",
            },
            {
              id: 13,
              label: "④ 크레인 작업반경 내 출입금지 및 급격한 조작금지",
              is_checked: "",
              title: "3. 크레인 작업",
            },
            {
              id: 14,
              label: "① 출입문 연동장치 등 리프트/화물용 승강기 각종 방호장치 정상 기능 유지",
              is_checked: "",
              title: "4. 기타 운반기계 작업",
              titleColor: "#f9f9f9",
            },
            {
              id: 15,
              label: "② 승강로 바닥 주변에 방호울 설치",
              is_checked: "",
              title: "4. 기타 운반기계 작업",
            },
            {
              id: 16,
              label: "③ 화물 이탈 방지 등을 위한 컨베이어 방호장치 부착",
              is_checked: "",
              title: "4. 기타 운반기계 작업",
            },
            {
              id: 17,
              label: "④ 수리ㆍ점검 중 전원 차단 및 ‘조작금지’ 표지판 부착",
              is_checked: "",
              title: "4. 기타 운반기계 작업",
            },
          ],
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              headerNATitle: "N/A",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "추락위험을 예방할 수 있는 안전대책",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "낙하위험을 예방할 수 있는 안전대책",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "전도위험을 예방할 수 있는 안전대책",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "협착위험을 예방할 수 있는 안전대책",
                  is_checked: "",
                },
              ],
            },
          ],
        },
      ];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectionList: [],
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },

        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
